import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ConfirmationBodyContainer from '../containers/ConfirmationBodyContainer';
import BackToListing from './BackToListing';
import ConfirmationContent from './ConfirmationContent';
import ConfirmationHeader from './ConfirmationHeader';
import ConfirmationLivestream from './ConfirmationLivestream';
import ConfirmationReservationInfo from './ConfirmationReservationInfo';
import FocusTrap from '../../../../shared/FocusTrap';
import EmbedFooter from '../../../components/EmbedFooter';
import { RoktPlaceholder } from '../../../containers/Analytics/Rokt';
import CartSummaryContainer from '../../../views/checkout/containers/CartSummaryContainer';
import { ConfirmationCartSummarySkeleton } from './ConfirmationCartSummarySkeleton';

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.confirmationOverlay = React.createRef();
  }
  componentDidMount() {
    this.confirmationOverlay?.current?.focus();
    if (this.props.queueIt) {
      fetch('/iframe-queue-cancel/' + this.props.listingSlug, { mode: 'no-cors'}).then((response)=>{});
    }
  }
  render() {
    return (
      <FocusTrap
        fallback={'.confirmation-wrap'}
        focusTrapOptions={{
          allowOutsideClick: true,
        }}
        active={this.props.activeTrap}
      >
        <dialog
          className="confirmation-wrap"
          aria-modal="true"
          aria-labelledby="confirmation-page-header"
          tabIndex="-1"
          ref={this.confirmationOverlay}
        >
          <div className="confirmation">
            <div className="confirmation__contents">
              <main className="confirmation__main">
                <ConfirmationHeader pending={!!this.props.pending}>
                  {!Object.keys(this.props.livestreamData).length && (
                    <ConfirmationReservationInfo
                      confirmationNumber={this.props.confirmationNumber}
                      email={this.props.email}
                      pending={!!this.props.pending}
                      showTooltip={this.props.showTooltip}
                      ticketsUrl={this.props.ticketsUrl}
                    />
                  )}
                </ConfirmationHeader>
                <ConfirmationLivestream streamData={this.props.livestreamData} />
                <ConfirmationBodyContainer>
                  <ConfirmationContent content={this.props.content} />
                  <BackToListing queueOn={this.props.queueOn} />
                  <RoktPlaceholder />
                </ConfirmationBodyContainer>
              </main>
              <aside className="confirmation__aside">
                {!this.props.isFetching && <CartSummaryContainer hideEventDateTime= {this.props.hideEventDateTime}/>}
                {this.props.isFetching && <ConfirmationCartSummarySkeleton />}
              </aside>
            </div>
            <EmbedFooter />
          </div>
        </dialog>
      </FocusTrap>
    );
  }
}

Confirmation.propTypes = {
  confirmationNumber: PropTypes.string,
  email: PropTypes.string,
  events: PropTypes.arrayOf(PropTypes.object),
  ticketsUrl: PropTypes.string,
  content: PropTypes.string,
  queueOn: PropTypes.bool,
  queueIt: PropTypes.bool,
  hideEventDateTime: PropTypes.bool,
  onClickShareTwitter: PropTypes.func,
  onClickShareFacebook: PropTypes.func,
  facebookAppId: PropTypes.string,
  livestreamData: PropTypes.object,
  listingSlug: PropTypes.string,
  activeTrap: PropTypes.bool,
  showTooltip: PropTypes.bool,
};

Confirmation.defaultProps = {
  content: '',
  listingSlug: '',
  activeTrap: true,
};

export default Confirmation;
